import script from "./LuckyJackpot.vue?vue&type=script&setup=true&lang=js"
export * from "./LuckyJackpot.vue?vue&type=script&setup=true&lang=js"

import "./LuckyJackpot.vue?vue&type=style&index=0&id=55d2b1be&scoped=true&lang=css"

import exportComponent from "L:\\vuexiangmu\\oppt2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55d2b1be"]])

export default __exports__